enum Arrows {
  RIGHT_ARROW = '→',
  DOWN_ARROW = '↓',
  LEFT_ARROW = '←',
}

export default Arrows;
